import { SentryTraced } from "@sentry/nestjs"
import { z } from "zod"

import { commonFlags, SentryCommand } from "../types/index.js"

export default class Login extends SentryCommand<object> {
  static override args = {}
  static override description = "Login to the Supernova"
  static override examples = ["<%= config.bin %> <%= command.id %>"]
  static override flags = commonFlags

  get commandId(): string {
    return Login.id
  }

  get configSchema() {
    return z.object({})
  }

  @SentryTraced()
  public async run(): Promise<void> {
    const success = await this.performLogin()
    if (!success) {
      this.error("Login timed out. Please try again.")
    }
  }
}
